import { Component, OnInit, ViewChild, Input, SimpleChanges, OnDestroy, OnChanges } from '@angular/core';
import { ChartType } from 'app/modules/domain/enums/ChartType';
import { RouteInformation } from 'app/modules/domain/models/branching';
import { MapsService } from 'app/modules/maps';
import { ChartDataSets, ChartOptions } from 'chart.js';
import * as Chart from 'chart.js';
import { BaseChartDirective, Color } from 'ng2-charts';
import { RouteDetailViewModel } from '../../viewModels/route-detail-viewmodel';
import { BranchingDomainService } from './services/branching.domain.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import BranchConstants from 'app/modules/shared/constants/branch-constant';
import { TranslateService } from 'ng2-translate';
import { BranchingApiService } from './services/branching.api.service';
import { HelperMethods } from './Helpers/herlperMethods';


@Component({
  selector: 'app-branching-containers',
  templateUrl: './branching-containers.component.html',
  styleUrls: ['./branching-containers.component.scss']
})
export class BranchingContainersComponent implements OnInit, OnDestroy, OnChanges {
  public totalRouteCount = 0;
  public parentData: any[] = [];
  public chartOneTitle = BranchConstants.chartOneTitle;
  public legend = true;
  public chartTypes1 = BranchConstants.chartTypes1;
  public chartTypes2 = BranchConstants.chartTypes2;
  public selectedChart1 = 'PIE';
  public selectedChart2 = 'LINE';
  public chart: any;
  public summaryChart: any;
  public lineChartData: ChartDataSets[] = [{ data: [], label: '' }];
  private lowHour: string[] = BranchConstants.lowHour;
  private peakMorningHour: string[] = BranchConstants.peakMorningHour;
  private peakEvnHour: string[] = BranchConstants.peakEvnHour;
  private letters: string[] = BranchConstants.letters;
  public pieChartLabels: string[] = [];
  public pieChartData: number[] = [];
  public pieChartDataByPercent: any[] = [];
  public ChartType = 'pie';
  public timeArray: any[] = [];
  public keys: any[] = [];
  public routeData: any[] = [];
  public polyLineArray: any[] = [];
  public polyLines: any[] = [];
  public lineChartDataArray: any[] = [];
  public dataGroepedByHours: any[] = [];
  public lineRoute: any[] = [];
  public datasets: any[] = [];
  public counterName = 0;
  public counterColor = 0;
  public sectionDataParent: any[] = [];
  public selectedchartType = 'LINE';
  public checkIfDataExist = true;
  public aggregate = true;
  public groupedDataByPolyLine;
  public branchingCountPerHour;
  public branchingCountPerHourAndMinutes;
  public startDate;
  public endDate;
  public summaryDatasets: any[] = [];
  public peakMPercentage: any[] = [];
  public peakEPercentage: any[] = [];
  public lowPercentage: any[] = [];
  public comparisionData;
  public checkPeakAndLow = false;
  branchingData: any[] = [];
  @ViewChild(BaseChartDirective)
  public piechart: BaseChartDirective;
  public aggregateLineRoute: any;
  public aggregateGroupedDataArrayByPolyline: any[];
  public aggregateDataArray: any[];
  public Route_Information: RouteInformation[] = [];
  public initialData;
  public initialParentData;
  public counter = 0;
  public allBranchingData;
  private LineChartLables;
  public showPercentages = true;
  public font;
  public pieChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    legend: {
      position: 'right', align: 'end',
      labels: {
        fontColor: 'black',
        fontFamily: 'Arial'
      },
    },

    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
        }
      }
    },
    plugins: {
      datalabels: {

        formatter: (value) => {
          let percentageString;
          if (value >= 2) {
            percentageString = value.toFixed(2) + '%';
            return percentageString;
          } else {
            percentageString = '';
            return percentageString;
          }

        },
        color: '#fff',
        font: { size: 12 },
        anchor: 'end',
        align: 'start'

      }
    },

    scales: {

      xAxes: [{
        display: false,
        ticks: {
          max: 100,
          min: 0,
          stepSize: 10,
        },
      }],
      yAxes: [],

    },

  };
  public lineChartOption: any = {
    legend: {
      display: true
    },
    tooltips: {
      mode: 'label',
      callbacks: {
        label: function (t, d) {
          let dstLabel = d.datasets[t.datasetIndex].label;
          let yLabel = t.yLabel;
          return dstLabel + ': ' + yLabel + '%';
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let percentageString = '';
          return percentageString;
        },
        color: '#fff',
      }
    },
    scales: {
      xAxes: [
        {
          display: true,
          ticks: {

            stepSize: 50,
          },
          gridLines: {
            color: 'rgba(171,171,171,1)',
            lineWidth: 1
          },
          scaleLabel: {
            display: true,
            labelString: this.translate.instant('TIMEOFDAY')
          }
        },
      ],
      yAxes: [{
        display: true,
        ticks: {
          max: 100,
          min: 0,
          stepSize: 10,
        },
        scaleLabel: {
          display: true,
          labelString: 'Percentage(%)'
        }
      }],
      responsive: true,
    },

    lineTension: 1,
    cubicInterpolationMode: 'default',
    skipLabels: 3,

  };
  public StackedChartOption: any = {
    legend: {
      display: true
    },
    tooltips: {
      mode: 'label',
      callbacks: {
        label: function (t, d) {
          let dstLabel = d.datasets[t.datasetIndex].label;
          let yLabel = t.yLabel;
          return dstLabel + ': ' + yLabel + '%';
        }
      }
    },

    plugins: {
      datalabels: {
        formatter: (value) => {
          let percentageString;
          let val = parseFloat(value);
          if (val >= 5 && this.aggregate === true && this.showPercentages) {
            percentageString = val.toFixed(1) + '%';
            return percentageString;
          } else {
            percentageString = '';
            return percentageString;
          }

        },

        color: '#fff',
        font: { size: 10 },

      }
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          display: true,
          gridLines: {
            color: 'rgba(171,171,171,1)',
            lineWidth: 1
          },
          scaleLabel: {
            display: true,
            labelString: this.translate.instant('TIMEOFDAY')
          }
        }],
      yAxes: [{
        stacked: true,
        display: true,
        ticks: {
          max: 100,
          min: 0,
          stepSize: 10,
        },
        scaleLabel: {
          display: true,
          labelString: 'Percentage'
        }
      }],
      responsive: true,
    },
    lineTension: 0,
    cubicInterpolationMode: 'default',
    skipLabels: 3,
  };
  public ComparisonChartOption: any = {
    legend: {
      position: 'right', align: 'end',
      labels: {
        fontColor: 'black',
        fontFamily: 'Arial'
      },
    },
    tooltips: {
      mode: 'label',
      callbacks: {
        label: function (t, d) {
          let dstLabel = d.datasets[t.datasetIndex].label;
          let yLabel = t.yLabel;
          return dstLabel + ': ' + yLabel + '%';
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: (value) => {
          let percentageString;
          if (value >= 10) {
            percentageString = value.toFixed(2) + '%';
            return percentageString;
          } else {
            percentageString = '';
            return percentageString;
          }

        },
        color: '#fff',
      }
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          display: true,
          gridLines: {
            color: 'rgba(171,171,171,1)',
            lineWidth: 1
          },

        }],
      yAxes: [{
        stacked: true,
        display: true,
        ticks: {
          max: 100,
          min: 0,
          stepSize: 10,
        },

      }],
      responsive: true,
    },
    lineTension: 0,
    cubicInterpolationMode: 'default',
    skipLabels: 3,
  };
  @Input() routeDetailList: RouteDetailViewModel[];
  @Input() currentRoute: RouteDetailViewModel;

  // tslint:disable-next-line:member-ordering
  public pieChartPlugins = [pluginDataLabels];
  // tslint:disable-next-line:member-ordering
  colors: Color[] = BranchConstants.GraphColors;
  // tslint:disable-next-line:member-ordering
  public timesWithInterval: any[] = [];
  // tslint:disable-next-line:member-ordering
  daysList: any[] = BranchConstants.daysList;
  // tslint:disable-next-line:member-ordering
  @Input() MO: any[];
  // tslint:disable-next-line:member-ordering
  @Input() TU: any[];
  // tslint:disable-next-line:member-ordering
  @Input() WE: any[];
  // tslint:disable-next-line:member-ordering
  @Input() THU: any[];
  // tslint:disable-next-line:member-ordering
  @Input() FR: any[];
  // tslint:disable-next-line:member-ordering
  @Input() SAT: any[];
  // tslint:disable-next-line:member-ordering
  @Input() SUN: any[];
  // tslint:disable-next-line:member-ordering
  public selectedFromDate: any;
  // tslint:disable-next-line:member-ordering
  public selectedToDate: any;
  // tslint:disable-next-line:member-ordering
  public allTime: any[] = [];
  // tslint:disable-next-line:member-ordering
  dates: Date[] = [];
  constructor(private mapsService: MapsService, private branchingDomain: BranchingDomainService, private sr: BranchingApiService, private translate: TranslateService) { }

  ngOnInit() {
    this.dates = HelperMethods.getDateList(this.currentRoute.startDate, this.currentRoute.endDate, this.currentRoute.days);
    this.selectedFromDate = this.dates[0];
    this.selectedToDate = this.dates[this.dates.length - 1];
    this.timesWithInterval = HelperMethods.createArrayPassedOnTime(0, '0', 24, this.routeDetailList);
    this.allTime = HelperMethods.createArrayPassedOnTimePerHoure(0, 23);
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentRoute'] !== undefined && !changes['currentRoute'].firstChange) {
      this.dates = HelperMethods.getDateList(this.currentRoute.startDate, this.currentRoute.endDate, this.currentRoute.days);
      this.selectedFromDate = this.dates[0];
      this.selectedToDate = this.dates[this.dates.length - 1];
      this.timesWithInterval = HelperMethods.createArrayPassedOnTime(0, '0', 24, this.routeDetailList);
      this.allTime = HelperMethods.createArrayPassedOnTimePerHoure(0, 23);
      this.startDate = HelperMethods.formatDate(this.selectedFromDate);
      this.endDate = HelperMethods.formatDate(this.selectedToDate);
      // tslint:disable-next-line:curly
      if (this.chart !== undefined) this.chart.destroy();
      this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
    }
  }

  periodChangedHandler(ev) {
    this.allTime = [];
    this.timesWithInterval = [];
    this.allTime = ev.allTime;
    this.timesWithInterval = ev.timesWithInterval;
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  startDatachangeHandler(ev) {
    this.selectedFromDate = ev;
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  endDatachangeHandler(ev) {
    this.selectedToDate = ev;
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  ngOnDestroy(): void {
    this.mapsService.removeBranchingLines();
  }
  getBranchingData(startDate, endDate, id) {
    this.branchingData = [];
    this.branchingDomain.getBranchingData(new Date(startDate), new Date(endDate), id).subscribe((res: any[]) => {

      this.allBranchingData = res;
      this.filterDataBydays(res);
      this.processData();
      this.calculatePieChart(this.groupedDataByPolyLine);
      this.mapsService.drawBranchingPolylines(this.parentData);
      // tslint:disable-next-line:curly
      if (this.piechart !== undefined) this.piechart.chart.update();
      // if (this.chart !== undefined) this.chart.update();
    }, err => {
      this.checkIfDataExist = false;
    });
  }

  filterDataBydays(res) {
    if (this.daysList.length >= 0) {
      res.forEach(element => {
        let key: string = element.id;
        let date = new Date(key.split('|')[1]);
        let day = date.getDay();
        let check = this.daysList.indexOf('' + day) > -1;
        if (check) { this.branchingData.push(element); }
      });
    } else { this.branchingData = res; }
  }
  calculatePieChart(dataGroupedByPolyLine) {
    this.totalRouteCount = 0;
    this.pieChartData = [];
    this.parentData = [];
    this.lineChartDataArray = [];
    this.pieChartDataByPercent = [];
    this.pieChartLabels = [];
    let counter = 0;
    this.Route_Information = [];
    this.LineChartLables = [];

    let distance = [];
    let duration = [];
    dataGroupedByPolyLine.forEach((element, i) => {
      this.totalRouteCount += element.length;
      this.LineChartLables.push(this.letters[counter] + ' - ' + element[0].brachInfo.summary);
      this.pieChartData.push(element.length);
      this.pieChartLabels.push(this.letters[counter] + ' - ' + element[0].brachInfo.summary);
      this.parentData.push(element[0].brachInfo.polyline);
      this.lineChartDataArray.push(element);
      // tslint:disable-next-line:radix
      let dis = parseInt(element[0].brachInfo.distance) / 1000;
      distance.push(dis.toFixed(1));

      duration.push(element[0].brachInfo.duration);

      counter++;
    });
    this.pieChartData.forEach((x, i) => {
      let percentage = parseFloat(((x * 100) / this.totalRouteCount).toFixed(2));
      this.pieChartDataByPercent.push(percentage);
      this.Route_Information.push(new RouteInformation(this.colors[0].backgroundColor[i], this.pieChartLabels[i], distance[i], duration[i], percentage));

    });
    if (this.counter === 0) {
      this.initialData = this.pieChartDataByPercent;
      this.initialParentData = this.parentData;
    }
    this.counter++;
    // tslint:disable-next-line:curly
    if (this.piechart !== undefined) this.piechart.chart.config.data.labels = this.pieChartLabels;
    this.getLowAndPeakPercentage(this.lowHour, this.peakMorningHour, this.peakEvnHour, this.groupedDataByPolyLine);

    this.checkchartType(this.selectedchartType);
    this.initSummaryStackedChart();
  }
  initLineChart(hour: string[], route: any[]) {
    if (route.length !== 0) {
      let lables = this.LineAndStackedChartLable(hour);
      // tslint:disable-next-line:curly
      if (this.chart !== undefined) this.chart = null;
      this.chart = new Chart('canvas', {
        type: 'line',
        data: {
          labels: lables,
          datasets: this.createChartDataset(route),
        },
        options: this.lineChartOption
      });
    } else {
      this.checkIfDataExist = false;
    }

  }
  initStackedChart(hour: string[], route: any[]) {
    if (route.length !== 0) {
      let lables = this.LineAndStackedChartLable(hour);
      this.chart = new Chart('canvas', {
        type: 'bar',
        data: {
          labels: lables,
          datasets: this.createChartDataset(route),
        },
        options: this.StackedChartOption
      });
    } else {
      this.checkIfDataExist = false;
    }
  }
  initSummaryStackedChart() {
    let lables = BranchConstants.summaryStackedChartLables;
    // tslint:disable-next-line:curly
    if (this.summaryChart !== undefined) this.summaryChart.destroy();
    this.summaryChart = new Chart('canvasOne', {
      type: 'bar',
      data: {
        labels: lables,
        datasets: this.createComparionDataset(),
      },
      options: this.ComparisonChartOption
    });
  }

  LineAndStackedChartLable(hour) {
    let lables = hour;
    if (hour.length < 4) {
      lables = [];
      hour.forEach(element => {
        // tslint:disable-next-line:radix
        let number = parseInt(element) + 1;

        // tslint:disable-next-line:curly
        if (hour[0] === '16')
          lables.push(element + '-' + number);
        // tslint:disable-next-line:curly
        else
          lables.push(element + '- 0' + number);
      });
    }
    return lables;
  }
  groepDataPerHourOrMin() {
    this.dataGroepedByHours = [];
    this.groupedDataByPolyLine.forEach(element => {
      if (this.aggregate) {
        this.dataGroepedByHours.push(this.groupBy(element, h => h.time.split(':')[0]));
      } else {
        this.dataGroepedByHours.push(this.groupBy(element, h => h.time.split(':')[0] + ':' + h.time.split(':')[1]));
      }
    });
  }
  createLineDataOfEachRoute(HourArray: string[], branchingDataGroup) {
    this.lineRoute = [];
    this.groepDataPerHourOrMin();
    this.dataGroepedByHours.forEach(element => {
      this.routeData = [];
      HourArray.forEach(p => {
        let items = element.get(p);
        let countPerHourAndMinutes = branchingDataGroup.get(p);
        if (items === undefined) {
          this.routeData.push('');
        } else {
          this.routeData.push(((items.length * 100) / countPerHourAndMinutes.length).toFixed(1));
        }
      });
      if (this.routeData.length > 0) {
        this.lineRoute.push(this.routeData);
      }
    });
  }
  getLowAndPeakPercentage(lowHour: string[], PeakMHour: string[], PeakEHour: string[], data: any) {
    this.dataGroepedByHours = [];
    this.lowPercentage = [];
    this.peakMPercentage = [];
    this.peakEPercentage = [];
    data.forEach(element => {

      if (this.aggregate) {
        this.dataGroepedByHours.push(this.groupBy(element, h => h.time.split(':')[0]));
      } else {
        this.dataGroepedByHours.push(this.groupBy(element, h => h.time.split(':')[0] + ':' + h.time.split(':')[1]));
      }
    });
    this.calculateLowHourPercentage(this.dataGroepedByHours, lowHour);
    this.calculatepeakMHourPercentage(this.dataGroepedByHours, PeakMHour);
    this.calculatepeakEHourPercentage(this.dataGroepedByHours, PeakEHour);
  }
  calculateLowHourPercentage(data, lowHour) {

    let totalCount = this.getTotalcountPerMoment(data, lowHour);
    data.forEach((element, i) => {
      let countOf = 0;

      lowHour.forEach(p => {
        let items = element.get(p);

        if (items === undefined) {
        } else {
          countOf += items.length;
        }
      });
      if (countOf >= 0) {
        let percentage = countOf * 100 / totalCount;
        this.lowPercentage.push(parseFloat(percentage.toFixed(2)));
      }
    });

  }
  calculatepeakMHourPercentage(data, peakMHour) {
    let totalCount = this.getTotalcountPerMoment(data, peakMHour);

    data.forEach((element, i) => {
      let countOf = 0;
      peakMHour.forEach(p => {
        let items = element.get(p);

        if (items === undefined) {
        } else {
          countOf += items.length;
        }
      });
      if (countOf >= 0) {
        let percentage = (countOf * 100) / totalCount;
        this.peakMPercentage.push(parseFloat(percentage.toFixed(2)));
      }
    });
  }
  calculatepeakEHourPercentage(data, peakEHour) {
    let totalCount = this.getTotalcountPerMoment(data, peakEHour);
    data.forEach((element, i) => {
      let countOf = 0;
      peakEHour.forEach(p => {
        let items = element.get(p);

        if (items === undefined) {
        } else {
          countOf += items.length;
        }
      });
      if (countOf >= 0) {
        let percentage = (countOf * 100) / totalCount;
        this.peakEPercentage.push(parseFloat(percentage.toFixed(2)));
      }
    });
  }
  getTotalcountPerMoment(data, hour) {
    let totalCount = 0;
    data.forEach((element, i) => {
      hour.forEach(p => {
        let items = element.get(p);

        if (items === undefined) {
        } else {
          totalCount += items.length;
        }
      });
    });
    return totalCount;
  }
  getCountOfRoutePerPeriodOfTime(data, periodOfTime, arrayPercantage, totalCount) {
    data.forEach((element, i) => {
      let countOf = 0;
      periodOfTime.forEach(p => {
        let items = element.get(p);
        if (items === undefined) {
        } else {
          countOf += items.length;
        }
      });
      if (countOf >= 0) {
        let percentage = (countOf * 100) / totalCount;
        arrayPercantage.push(parseFloat(percentage.toFixed(2)));
      }
    });
  }
  calculateAggregatePerHour() {
    this.aggregateDataArray = [];
    this.aggregateLineRoute = [];
    this.aggregateGroupedDataArrayByPolyline = [];
    let aggregateByHour = [];
    this.dataGroepedByHours.forEach(element => {
      element.forEach(x => {
        let t = x.length / (60 / this.currentRoute.interval);
        this.aggregateDataArray.push({ hour: x[0].time.split(':')[0], polyline: x[0].brachInfo.polyline, totalPerHour: t });
      });
    });
    this.aggregateGroupedDataArrayByPolyline.push(this.groupBy(this.aggregateDataArray, h => h.polyline));
    this.aggregateGroupedDataArrayByPolyline.forEach(x => {
      x.forEach(y => {
        aggregateByHour.push(this.groupBy(y, h => h.hour));
      });
    });
    aggregateByHour.forEach(element => {
      let routeData = [];
      this.allTime.forEach(p => {
        let items = element.get(p);
        let countPerHour = this.branchingCountPerHour.get(p);
        if (items === undefined) {
          routeData.push('');
        } else {
          routeData.push(((items[0].totalPerHour * 100) / (countPerHour.length / (60 / this.currentRoute.interval))).toFixed(1));
        }
      });
      if (routeData.length > 0) {
        this.aggregateLineRoute.push(routeData);
      }
    });
  }

  createChartDataset(lineRoute) {
    this.datasets = [];
    this.counterColor = 0;
    this.counterName = 0;
    if (lineRoute.length > 0) {
      lineRoute.forEach((element, i) => {
        let color = this.getLineChartColor();
        this.datasets.push({
          data: element, label: this.getLableName(this.LineChartLables), borderColor: color, fill: false, borderWidth: 2, backgroundColor: color, pointBackgroundColor: 'rgba(77,83,96,1)', pointHoverBackgroundColor: '#fff'
        });
      });
      return this.datasets;
    }
  }
  createComparionDataset() {
    this.summaryDatasets = [];
    this.counterColor = 0;
    this.counterName = 0;
    if (this.pieChartDataByPercent.length > 0) {
      this.pieChartDataByPercent.forEach((element, i) => {
        let color = this.getLineChartColor();
        this.summaryDatasets.push({
          data: [element, this.lowPercentage[i], this.peakMPercentage[i], this.peakEPercentage[i]], label: this.getLableName(this.pieChartLabels), borderColor: color, fill: false, borderWidth: 2, backgroundColor: color, pointBackgroundColor: 'rgba(77,83,96,1)', pointHoverBackgroundColor: '#fff'
        });
      });
      this.checkIfDataExist = true;
      return this.summaryDatasets;
    } else {
      this.checkIfDataExist = false;
    }
  }
  getLableName(lables) {
    let name = '';
    for (let i = 0; i < 1; i++) {
      name += lables[this.counterName];
      this.counterName++;
    }
    return name;
  }
  getLineChartColor() {
    let colorArray = [];
    let color = '';
    for (let i = 0; i < this.colors.length; i++) {
      colorArray.push(this.colors[i].backgroundColor);
    }
    for (let i = 0; i < 1; i++) {
      color += colorArray[i][this.counterColor];
      this.counterColor++;
    }
    return color;
  }
  groupBy(list, keyGetter) {
    const map: Map<string, any[]> = new Map();

    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });

    return map;
  }
  chartSectionClicked(e: any): void {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        const clickedElementIndex = activePoints[0]._index;
        let res = [];
        this.groupedDataByPolyLine.forEach(function (val, key) {
          res.push({ polyline: key, value: val });
        });
        this.sectionDataParent = res[clickedElementIndex];
        this.mapsService.drawBranchingPolylines(this.parentData, this.sectionDataParent);
      }
    }

  }
  summaryClicked(e: any): void {
    let datasetIndex = e._datasetIndex;
    let res = [];
    this.groupedDataByPolyLine.forEach(function (val, key) {
      res.push({ polyline: key, value: val });
    });
    this.sectionDataParent = res[datasetIndex];
    this.mapsService.drawBranchingPolylines(this.parentData, this.sectionDataParent);
  }

  toggleSummaryChart(e) {
    let chartType = e;
    if (chartType === ChartType.Pie) {
      this.ChartType = ChartType.Pie.toLocaleLowerCase();
      this.chartOneTitle = 'Summary';
      this.legend = true;
      this.checkPeakAndLow = false;
    } else if (chartType === ChartType.HorizontalBar) {
      this.ChartType = 'horizontalBar';
      this.chartOneTitle = 'Summary';
      this.legend = false;
      this.checkPeakAndLow = false;
    } else if (chartType === ChartType.Comparison) {
      // tslint:disable-next-line:curly
      if (this.summaryChart !== undefined) this.summaryChart.destroy();
      this.checkPeakAndLow = true;
      this.chartOneTitle = 'Comparision';
      this.initSummaryStackedChart();
      this.mapsService.drawBranchingPolylines(this.parentData);
    }
  }
  toggleChart(e) {
    this.selectedchartType = e;
    this.checkchartType(this.selectedchartType);
  }
  checkchartType(chartType) {
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    if (chartType === ChartType.Line && this.aggregate) {
      this.createLineDataOfEachRoute(this.allTime, this.branchingCountPerHour);
      this.calculateAggregatePerHour();
      this.initLineChart(this.allTime, this.aggregateLineRoute);
    } else if (chartType === ChartType.Line && !this.aggregate) {
      this.createLineDataOfEachRoute(this.timesWithInterval, this.branchingCountPerHourAndMinutes);
      this.initLineChart(this.timesWithInterval, this.lineRoute);
    } else if (chartType === ChartType.Stacked && this.aggregate) {
      this.createLineDataOfEachRoute(this.allTime, this.branchingCountPerHour);
      this.calculateAggregatePerHour();
      this.initStackedChart(this.allTime, this.aggregateLineRoute);
    } else if (chartType === ChartType.Stacked && !this.aggregate) {
      this.createLineDataOfEachRoute(this.timesWithInterval, this.branchingCountPerHourAndMinutes);
      let tmesWithInterval = this.timesWithInterval.slice(0, -1);
      this.initStackedChart(tmesWithInterval, this.lineRoute);
    }
  }
  aggregateByHour(e) {
    this.chart.destroy();
    if (e) {
      this.aggregate = true;
      if (this.selectedchartType === ChartType.Line && this.aggregate) {
        this.createLineDataOfEachRoute(this.allTime, this.branchingCountPerHour);
        this.calculateAggregatePerHour();
        this.initLineChart(this.allTime, this.aggregateLineRoute);
      } else if (this.selectedchartType === ChartType.Stacked && this.aggregate) {
        this.createLineDataOfEachRoute(this.allTime, this.branchingCountPerHour);
        this.calculateAggregatePerHour();
        this.initStackedChart(this.allTime, this.aggregateLineRoute);

      }
      this.chart.update();
    } else {
      this.aggregate = false;
      this.chart.destroy();
      if (this.selectedchartType === ChartType.Line && !this.aggregate) {
        this.createLineDataOfEachRoute(this.timesWithInterval, this.branchingCountPerHourAndMinutes);
        this.initLineChart(this.timesWithInterval, this.lineRoute);
      } else if (this.selectedchartType === ChartType.Stacked && !this.aggregate) {
        this.createLineDataOfEachRoute(this.timesWithInterval, this.branchingCountPerHourAndMinutes);
        let tmesWithInterval = this.timesWithInterval.slice(0, -1);
        this.initStackedChart(tmesWithInterval, this.lineRoute);

      }
      this.chart.update();
    }
  }

  showPercentage(e) {
    if (this.selectedchartType === ChartType.Stacked && this.aggregate) {
      this.chart.destroy();
      this.showPercentages = e;
      this.initStackedChart(this.allTime, this.aggregateLineRoute);
      this.chart.update();
    }
  }
  processData() {
    this.groupedDataByPolyLine = [];
    this.branchingCountPerHour = [];
    this.comparisionData = [];
    let data = [];
    this.branchingCountPerHourAndMinutes = [];
    let dataPerMoment = [];

    if (this.branchingData !== undefined && this.branchingData.length > 0) {
      this.checkIfDataExist = true;
      data = this.processAlBranchingData();
      this.branchingData.forEach(element => {
        element.items.forEach(el => {
          let time = el.time.split(':');
          this.allTime.forEach(t => {
            if (time[0] === t) {
              dataPerMoment.push(el);
            }
          });
        });
      });
      let groupedDataByPolyLine = this.groupBy(dataPerMoment, p => p.brachInfo.polyline);
      let comparisionData = this.groupBy(data, p => p.brachInfo.polyline);

      let SummaryData = this.sortMapObject(groupedDataByPolyLine);
      let comparisionValues = this.sortMapObject(comparisionData);

      this.groupedDataByPolyLine = this.groupBy(SummaryData, p => p.brachInfo.polyline);
      this.comparisionData = this.groupBy(comparisionValues, p => p.brachInfo.polyline);
      this.branchingCountPerHour = this.groupBy(SummaryData, p => p.time.split(':')[0]);
      this.branchingCountPerHourAndMinutes = this.groupBy(SummaryData, h => h.time.split(':')[0] + ':' + h.time.split(':')[1]);
    } else {
      this.checkIfDataExist = false;
    }
  }
  processAlBranchingData() {
    let data = [];
    this.allBranchingData.forEach(element => {
      element.items.forEach(el => {
        data.push(el);
      });
    });
    return data;
  }
  sortMapObject(dataGroupedByPolyLine) {
    let objArray = [];
    let array = [];
    dataGroupedByPolyLine.forEach((value, key) => {
      objArray.push({ key: key, value: value });
    });
    objArray.sort((a, b) => parseFloat(b.value.length) - parseFloat(a.value.length));

    objArray.forEach(element => {
      array.push(...element.value);
    });
    return array;
  }

  MondayClicked(e) {

    if (e === 'x') {
      HelperMethods.removeElementFromStringArray('1', this.daysList);
    } else {
      this.daysList.push(e);
    }
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  TuisdayClicked(e) {
    if (e === 'x') {
      HelperMethods.removeElementFromStringArray('2', this.daysList);
    } else {
      this.daysList.push(e);
    }
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  WensdayClicked(e) {
    if (e === 'x') {
      HelperMethods.removeElementFromStringArray('3', this.daysList);
    } else {
      this.daysList.push(e);
    }
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  ThursdayClicked(e) {
    if (e === 'x') {
      HelperMethods.removeElementFromStringArray('4', this.daysList);
    } else {
      this.daysList.push(e);
    }
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  FridayClicked(e) {
    if (e === 'x') {
      HelperMethods.removeElementFromStringArray('5', this.daysList);
    } else {
      this.daysList.push(e);
    }
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  SaterdayClicked(e) {
    if (e === 'x') {
      HelperMethods.removeElementFromStringArray('6', this.daysList);
    } else {
      this.daysList.push(e);
    }
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
  SundayClicked(e) {
    if (e === 'x') {
      HelperMethods.removeElementFromStringArray('0', this.daysList);
    } else {
      this.daysList.push(e);
    }
    this.startDate = HelperMethods.formatDate(this.selectedFromDate);
    this.endDate = HelperMethods.formatDate(this.selectedToDate);
    // tslint:disable-next-line:curly
    if (this.chart !== undefined) this.chart.destroy();
    this.getBranchingData(this.startDate, this.endDate, this.currentRoute.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/branching-container/branching-containers.component.ts